import PrivateClientAdvisorView from './views/private-client-advisor.js';

export default class PrivateClientAdvisor {
	constructor({
		el,
		init_chat
	}) {
		this.view = new PrivateClientAdvisorView({
			el,
			init_chat
		});
	}
}